import apiConfig from '../config/api/apiConfig';
import { httpService } from './httpService';

const GetRecommendedProducts = async (queryParams) => {
  const { data } = await httpService().get(apiConfig.getWidgets(queryParams));
  return data.widgets;
};

export { GetRecommendedProducts };
